
import Hero from './components/Hero';
import About from './components/About';
import HowItWorks from './components/HowItWorks';
import FeaturedProjects from './components/FeaturedProjects';
import GetStartup from './components/GetStartup';
import Footer from './components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-900 via-blue-950 to-black">
      <Hero />
      <About />
      <HowItWorks />
      <FeaturedProjects />
      <GetStartup />
      <Footer />
    </div>
  );
};

export default HomePage;
